import { i18n } from '@lingui/core';
import { NavBar, Logo } from '@landr/maestro';
import React from 'react';
import { NavDivider } from '../../styled.es.js';
import { NavBarMainNav } from './components/NavBarMainNav/NavBarMainNav.es.js';
import NavBarSideNav from './components/NavBarSideNav/NavBarSideNav.es.js';
import { getWebAppLink, openHomeLink, openGuestSiteLink } from '../../../../utils/links.es.js';
import { useNavBarContext } from '../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { getGuestSiteLink } from '@landr/core';

var NavBarContent = function NavBarContent(_ref) {
  var isAuthenticated = _ref.isAuthenticated;
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env,
    language = _useNavBarContext.language;
  var hrefURl = isAuthenticated ? getWebAppLink(env, '/dashboard') : getGuestSiteLink(env, "/".concat(language, "/"));
  var handleOnClick = function handleOnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    isAuthenticated ? openHomeLink(env) : openGuestSiteLink(env, "/".concat(language, "/"));
  };
  return /*#__PURE__*/React.createElement(NavBar, {
    menuLabel: i18n._(
    /*i18n*/
    {
      id: "mUJrT6"
    })
  }, /*#__PURE__*/React.createElement(NavBar.Brand, {
    onClick: handleOnClick,
    href: hrefURl
  }, /*#__PURE__*/React.createElement(Logo, {
    label: "LANDR"
  })), /*#__PURE__*/React.createElement(NavDivider, null), /*#__PURE__*/React.createElement(NavBar.Menu, null, /*#__PURE__*/React.createElement(NavBarMainNav, null)), /*#__PURE__*/React.createElement(NavBar.SubMenu, null, /*#__PURE__*/React.createElement(NavBarSideNav, null)));
};

export { NavBarContent };
